import { createElement } from "../../../utils/DOMutils";
import { checkEmailValidity, getEmailErrorMessage } from "../emailBlocking";

const createErrorMessage = (element, message) => {
    const wrapper = createElement("span", { class: "form-error" }, message);
    element.parentElement.appendChild(wrapper);
};

const removeErrorMessages = (form) => {
    const errorMessages = form.querySelectorAll(".form-error");

    if (errorMessages.length === 0) return;

    errorMessages.forEach((errorMessage) => errorMessage.remove());
};

export const isValid = (form, formElements) => {
    removeErrorMessages(form);

    for (const element of formElements) {
        const elementName = element.name;
        const elementType = element.type;
        const elementValue = element.value;

        if (elementName && elementName === "Email" && elementValue) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailPattern.test(elementValue)) {
                createErrorMessage(element, "Please provide email in a valid format.");
                element.focus();

                return false;
            }

            if (
                formElements.Country &&
                formElements.Country.value &&
                !checkEmailValidity(elementValue.toLowerCase(), formElements.Country.value)
            ) {
                createErrorMessage(element, getEmailErrorMessage());
                element.focus();

                return false;
            }
        }

        if (
            element.required &&
            (!elementValue || (elementType && elementType === "checkbox" && !element.checked))
        ) {
            createErrorMessage(element, "This field is required.");
            element.focus();

            return false;
        }
    }

    return true;
};
